import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Reports({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2.5 -3 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M33.4922714 9.85026667c0 1.39666663-1.1442245 2.52933333-2.5551428 2.52933333-1.4109184 0-2.5551429-1.1326667-2.5551429-2.52933333 0-1.39666667 1.1442245-2.52933334 2.5551429-2.52933334 1.4109183 0 2.5551428 1.13266667 2.5551428 2.52933334zM23.0893245 20.1324667c0 1.3973333-1.1442245 2.5293333-2.5551429 2.5293333-1.4109183 0-2.5551428-1.132-2.5551428-2.5293333 0-1.3966667 1.1442245-2.5293334 2.5551428-2.5293334 1.4109184 0 2.5551429 1.1326667 2.5551429 2.5293334zM12.6863776 14.7282c0 1.3966667-1.1442245 2.5293333-2.55514291 2.5293333-1.41091836 0-2.55514285-1.1326666-2.55514285-2.5293333 0-1.3966667 1.14422449-2.5293333 2.55514285-2.5293333 1.41091841 0 2.55514291 1.1326666 2.55514291 2.5293333z" />
        <path d="M1.37094694 1.35906667V32.4330667H33.4920694M29.1304796 11.6386667l-6.5804694 6.944M18.116898 19.3183333l-5.7251633-3.4126666M1.37094694 23.9664667l6.87881633-7.5313334" />
      </g>
    </svg>
  )
}

Reports.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
